module.exports = __webpack_public_path__ + "assets/img/charge-point-icon.17ab7201.svg";